/** Why a proposed pivot layout was rejected. */
export enum PivotLayoutProblemEnum {
  Invalid = 'Invalid',
  NoDateField = 'NoDateField',
  OutsideLoadedDays = 'OutsideLoadedDays',
}

/** One failed rule on a proposed pivot layout. */
export type PivotLayoutProblem = { code: PivotLayoutProblemEnum; message: string }
